import {ReactComponent as Icon} from '@image/icon_humidity.svg';

const IconHumidity = () => {
    return   <Icon />;
};

export default IconHumidity;